export default __webpack_public_path__ + "static/media/demain_les_filles.591074b3.png";